module.exports = __webpack_public_path__ + "static/media/location2.b496ac53.svg";